import React from 'react';
import BackBar from '../components/BackBar';
import './Manifesto.css';

/*
 * The KACHNG Manifesto — signed-letter format on the dark system.
 * Structure: .m-strike = punch lines, .m-lead = raised voice,
 * .m-tagline = the green closing line. Pacing is the design.
 */

export default function Manifesto() {
  return (
    <div className="manifesto-page">
      <BackBar />

      <article className="manifesto">
        <header className="m-header">
          <div className="m-kicker">The KACHNG Manifesto</div>
          <h1 className="m-title">Everyone profits from what you buy.</h1>
        </header>

        <p className="m-body">
          Every purchase you make creates data.
          <br />
          What. Where. When. For how much.
        </p>

        <p className="m-body">
          It&rsquo;s some of the most valuable information on earth.
          <br />
          Retailers study it. Advertisers bid on it. Brands take advantage
          of it. Corporations build empires on it.
        </p>
        <p className="m-strike">Except you.</p>
        <p className="m-body">
          Think about that. Oura tracks your sleep. Apple&nbsp;Watch tracks
          your steps. Coinbase tracks your crypto. TikTok tracks your
          interests. Your bank tracks your transactions.
        </p>

        <p className="m-body m-lead">
          Nothing tracks your purchases. Nothing works for <em>you</em>.
        </p>

        <p className="m-body">
          Meanwhile, business has run on financial intelligence for decades.
          Every dollar tracked. Every expense optimized. Every refund
          recovered. Every behavior studied &mdash; including yours.
        </p>

        <p className="m-body">
          That&rsquo;s not luck. That&rsquo;s infrastructure. A system built
          to win.
        </p>

        <p className="m-strike">It&rsquo;s not a fair fight.</p>

        <p className="m-body">
          You were given a shoebox and told to be more careful.
          <br />
          And you&rsquo;ve spent years wondering:{' '}
          <em>where did my money go?</em>
        </p>

        <p className="m-body">
          We don&rsquo;t believe you&rsquo;re bad with money.
          <br />
          We believe you&rsquo;ve been flying blind &mdash; and blamed for
          the crash.
        </p>

        <p className="m-body">
          KACHNG exists to take it back. To level the playing field. To give
          one person, one couple, one family the same command over their
          money that companies have had for decades. To turn the paper trail
          of your life into money back, protection, and answers &mdash;
          automatically. No manual. No finance degree.
        </p>

        <p className="m-body">
          Because this was never really about money.
          <br />
          It&rsquo;s about security. Time. The freedom to think about
          literally anything else.
        </p>

        <p className="m-body">
          The intelligence was always yours.
          <br />
          We&rsquo;re just returning it.
        </p>

        <p className="m-tagline">Your receipts. Your money.</p>

        <footer className="m-signature">
          <span className="m-signature-name">Joshua Gibson</span>
          <span className="m-signature-role">Founder</span>
        </footer>
      </article>
    </div>
  );
}